/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState} from 'react';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';

import {images} from '../../../../../constants/image';
import {
  Modal,
  Select,
  Button,
  RangePicker,
  Input,
  DateTimePicker,
} from '../../../../../components';

// style
import {
  Typography,
  StyledIconClose,
  StyledModalTitle,
  StyledModalActions,
  Divider,
} from './ModalFilter.style';
import InputNumberRange from '../../../../../components/InputNumberRange/InputNumberRange';
import {error} from 'console';
import {number} from 'yup';

interface ModalFilterProps {
  visible: boolean;
  onClose?: () => void;
  handleClean?: () => void;
  handleFilter?: () => void;
  valueFilter?: any;
  valueRangePicker?: any;
  setValueFilter?: (any) => void;
  setValueRangePicker?: (any) => void;
  expireValueRangePicker?: any;
  setExpireValueRangePicker?: (any) => void;
  setOptionByType?: (any) => void;
  optionByType?: any;
  nameContainsList?: any;
  setNameContainsList?: (any) => void;
  numberRange?: any;
  setNumberRange?: (any) => void;
  referralTypeList?: any;
  processIdList?: any;
}

function ModalFilter({
  visible,
  onClose,
  handleClean,
  handleFilter,
  valueFilter,
  numberRange,
  setNumberRange,
  setValueRangePicker,
  expireValueRangePicker,
  setExpireValueRangePicker,
  setValueFilter,
  valueRangePicker,
  referralTypeList,
  processIdList,
}: ModalFilterProps) {
  const [isLoading, setIsLoading] = useState(false);

  const onChange = (name: string, event: any) => {
    setValueFilter((prevState: any) => ({
      ...prevState,
      [name]: event.target.value,
    }));
  };

  function createData(label: string, value: any) {
    return {
      label,
      value,
    };
  }

  const onChangeRangePicker = value => {
    setValueRangePicker(value);
  };

  const onChangeRangeExpirePicker = value => {
    setExpireValueRangePicker(value);
  };

  return (
    <Modal visible={visible} onClose={onClose}>
      <>
        <StyledModalTitle>Filter</StyledModalTitle>
        <StyledIconClose onClick={onClose}>
          <img src={images.icon_close} />
        </StyledIconClose>
        <Divider variant="middle" />
        <DialogContent>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Transaction no.
            </Typography>
            <Input
              type="number"
              name="transactionId_eq"
              placeholder="Enter transaction no."
              size="small"
              variant="outlined"
              value={valueFilter.transactionId_eq}
              onChange={e => onChange('transactionId_eq', e)}
              sx={{marginBottom: '0 !important'}}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Referral transaction date
            </Typography>
            <RangePicker
              value={valueRangePicker}
              onChange={onChangeRangePicker}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Referee’s Account ID
            </Typography>
            <Input
              type="text"
              name="accountId_eq"
              placeholder="Enter referee’s Account ID"
              size="small"
              variant="outlined"
              value={valueFilter.accountId_eq}
              onChange={e => onChange('accountId_eq', e)}
              sx={{marginBottom: '0 !important'}}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Referral code used
            </Typography>
            <Input
              type="text"
              name="referralCodeUsed_eq"
              placeholder="Enter referral code used"
              size="small"
              variant="outlined"
              value={valueFilter.referralCodeUsed_eq}
              onChange={e => onChange('referralCodeUsed_eq', e)}
              sx={{marginBottom: '0 !important'}}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Referral Creation ID
            </Typography>
            <Input
              type="text"
              name="referralCampaignNumberId_eq"
              placeholder="Enter referral Creation ID"
              size="small"
              variant="outlined"
              value={valueFilter.referralCampaignNumberId_eq}
              onChange={e => onChange('referralCampaignNumberId_eq', e)}
              sx={{marginBottom: '0 !important'}}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Referral type
            </Typography>
            <Select
              labelId="referralType_eq"
              displayEmpty
              variant="outlined"
              onChangeSelect={e => onChange('referralType_eq', e)}
              value={valueFilter.referralType_eq}
              placeholder="Select referral type"
              size="small"
              selectOptions={Object.keys(referralTypeList).reduce(
                (referralTypes: any, key) => {
                  referralTypes.push({
                    label: referralTypeList[key],
                    value: key,
                  });
                  return referralTypes;
                },
                []
              )}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Transaction status
            </Typography>
            <Select
              labelId="processId_eq"
              displayEmpty
              variant="outlined"
              onChangeSelect={e => onChange('processId_eq', e)}
              value={valueFilter.processId_eq}
              placeholder="Select transaction status"
              size="small"
              selectOptions={Object.keys(processIdList).reduce(
                (referralTypes: any, key) => {
                  referralTypes.push({
                    label: processIdList[key],
                    value: key,
                  });
                  return referralTypes;
                },
                []
              )}
            />
          </FormControl>
          <FormControl>
            <Typography variant="subtitle2" mb={2}>
              Points rewarded range
            </Typography>
            <InputNumberRange
              values={numberRange}
              onChange={(name: any, e: any) => {
                setNumberRange({
                  ...numberRange,
                  [name]: e.target.value,
                });
                onChange(
                  name === 'start'
                    ? 'pointsRewarded_gte'
                    : 'pointsRewarded_lte',
                  e
                );
              }}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Points expiry date
            </Typography>
            <RangePicker
              value={expireValueRangePicker}
              onChange={onChangeRangeExpirePicker}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Points status
            </Typography>
            <Select
              labelId="pointsStatus_eq"
              displayEmpty
              variant="outlined"
              onChangeSelect={e => onChange('pointsStatus_eq', e)}
              value={valueFilter.pointsStatus_eq}
              placeholder="Select points status"
              size="small"
              selectOptions={[
                createData('Active', 1),
                createData('Expired', 2),
              ]}
            />
          </FormControl>
        </DialogContent>
        <Divider variant="middle" />
        <StyledModalActions>
          <div className="btn-action-1">
            <Button variant="text" onClick={handleClean} loading={isLoading}>
              Clear
            </Button>
          </div>
          <div className="btn-action-2">
            <Button
              onClick={handleFilter}
              loading={isLoading}
              disabled={
                !valueFilter?.referralType_eq &&
                !valueFilter?.referralCampaignNumberId_eq &&
                !valueRangePicker[0] &&
                !valueRangePicker[1] &&
                !expireValueRangePicker[0] &&
                !expireValueRangePicker[1] &&
                !valueFilter?.accountId_eq &&
                !valueFilter?.processId_eq &&
                !valueFilter?.pointsRewarded_lte &&
                !valueFilter?.pointsRewarded_gte &&
                !valueFilter?.pointsStatus_eq &&
                !valueFilter?.transactionId_eq &&
                !valueFilter?.referralCodeUsed_eq
              }
            >
              Apply Filter
            </Button>
          </div>
        </StyledModalActions>
      </>
    </Modal>
  );
}
export default ModalFilter;
